<div class="row">
  <div class="row gx-4 g-0 perfect-scrollbar" *ngIf="allocatedLicences.length>0; else noLicences">
    <div class="col-4 d-flex mb-4" *ngFor="let allocatedLicence of allocatedLicences">
      <div class="card card-animate h-100 w-100" style="border:1px solid #5c6da0;">
        <div class="card-body d-flex flex-column">
          
          <div
            class="alert border-0 d-flex justify-content-between align-items-center mb-0 rounded-0 text-white py-2 px-3"
            role="alert"
            style="background-color:#5c6da0; margin-left:-1rem; margin-right:-1.05rem; margin-top:-1rem; width:calc(100% + 2.05rem);"
          >
            <p class="fs-14 text-uppercase fw-medium text-truncate mb-0">
              {{allocatedLicence.licenceType}}
            </p>
            <i
              class="bi bi-award fs-4"
              [ngClass]="allocatedLicence.systemOwned ? 'text-danger' : 'text-white'"
              [attr.title]="allocatedLicence.systemOwned 
                              ? 'System Owned Licence - cannot be edited or removed'
                              : 'Standard Licence'"
            >
            </i>
          </div>

          <div class="d-flex">
            <div class="ms-auto mt-2">
              <div class="list-inline-item edit" *ngIf="showEditQuantityIcon(allocatedLicence)">
                <a href="javascript:void(0);" class="text-primary d-inline-block edit-item-btn" id="create-btn" (click)="changeQuantity(allocatedLicence)">
                  <i class="ri-pencil-fill fs-16"></i>
                </a>
              </div>

              <div class="list-inline-item delete" *ngIf="showDeleteIcon(allocatedLicence)">
                <a href="javascript:void(0);" class="text-primary d-inline-block delete-item-btn" id="delete-btn" (click)="startCancelLicence(allocatedLicence)">
                  <i class="ri-delete-bin-fill text-danger"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-end justify-content-between mt-2">
            <div>
              <h4 class="fs-16 fw-semibold ff-secondary">
                <span>{{allocatedLicence.licenceName}}</span>
              </h4>                                      
            </div>
          </div>

          @if (allocatedLicence.licenceType==enumTextBundle ||
               allocatedLicence.licenceType==enumTextPoolBundle ||
               allocatedLicence.licenceType==enumTextUsage) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Zones: </strong>{{ (allocatedLicence.zoneNames && allocatedLicence.zoneNames.length>0) ? allocatedLicence.zoneNames.join(", ") : allocatedLicence.zoneName }}</span>
              </p>
            </div>
          }

          @if (allocatedLicence.licenceType==enumTextBundle) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Allowance: </strong>{{allocatedLicence.allowanceMbOrGb}}{{allocatedLicence.dataWeightCode ?? 'GB'}}</span>
              </p>
            </div>
          }

          @if (allocatedLicence.licenceType==enumTextPoolBundle) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Allowance: </strong>{{allocatedLicence.allowanceMbOrGb}}{{allocatedLicence.dataWeightCode ?? 'GB'}} x {{totalPlatformLicences}} Licences</span>
              </p>
            </div>
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Allowance Total: </strong>{{allocatedLicence.quantity * (allocatedLicence.allowanceMbOrGb ?? 0) * totalPlatformLicences}}{{allocatedLicence.dataWeightCode ?? 'GB'}}</span>
              </p>
            </div>
          }

          @if (allocatedLicence.licenceType==enumTextFeature) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Feature: </strong>{{allocatedLicence.featureName}}</span>
              </p>
            </div>
          }

          @if (allocatedLicence.licenceType==enumTextPlatform || (allocatedLicence.licenceType==enumTextFeature && allocatedLicence.quantityEnabled)) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>{{allocatedLicence.licenceType==enumTextPlatform ? '# of Licences' : '# of ' + allocatedLicence.featureName}}: </strong>{{allocatedLicence.numberOfEntities}}</span>
              </p>
            </div>
          }

          @if (allocatedLicence.licenceType==enumTextUsage) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Price per MB: </strong>£{{allocatedLicence.pricePerMb}}</span>
              </p>
            </div>
          }

          @if (allocatedLicence.licenceType==enumTextBundle ||
               (multiplePoolBundleQuantity && allocatedLicence.licenceType==enumTextPoolBundle) ||
               (multiplePlatformQuantity && allocatedLicence.licenceType==enumTextPlatform && allocatedLicence.platformAddOn)) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Quantity: </strong>{{allocatedLicence.quantity}}</span>
              </p>
            </div>
          }
          
          <div class="d-flex w-100">
            <p class="fs-12 mb-1 text-align-left text-muted">
              <span><strong>Start Date: </strong>{{allocatedLicence.startDate | date:'dd/MM/yyyy':'UTC'}}</span>
            </p>
          </div>
          
          <div class="d-flex w-100" *ngIf="allocatedLicence?.endDate">
            <p class="fs-12 mb-1 text-align-left text-muted">
              <span><strong>End Date: </strong>{{allocatedLicence.endDate | date:'dd/MM/yyyy':'UTC'}}</span>
            </p>
          </div>
          
          <div class="d-flex w-100">
            <p class="fs-12 mb-1 text-align-left text-muted">
              <span><strong>Price: </strong>£{{allocatedLicence.price}}</span>
            </p>
          </div>

          @if (allocatedLicence.licenceType==enumTextBundle ||
               (multiplePoolBundleQuantity && allocatedLicence.licenceType==enumTextPoolBundle) ||
               (multiplePlatformQuantity && allocatedLicence.licenceType==enumTextPlatform && allocatedLicence.platformAddOn)) {
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Total Price: </strong>£{{(allocatedLicence.quantity) * (allocatedLicence.price ?? 0)}}</span>
              </p>
            </div>
          }
          
          <div class="d-flex w-100">
            <p class="fs-12 mb-1 text-align-left text-muted">
              <span><strong>Status: </strong>{{getLicenceStatus(allocatedLicence)}}</span>
            </p>
          </div>
          
          <div class="mt-auto">
            <div class="d-flex w-100">
              <p class="fs-12 mb-1 text-align-left text-muted">
                <span><strong>Entered By: </strong>{{allocatedLicence.enteredByName}}</span>
              </p>
            </div>

            <div class="d-flex w-100">
              <p class="fs-12 mb-0 text-align-left text-muted">
                <span><strong>Entered Date: </strong>{{allocatedLicence.enteredDate| date:'dd/MM/yyyy':'UTC'}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noLicences>
    <div class="col-12">
      <p class="text-uppercase fw-medium text-muted text-truncate mb-3">No Licences Found</p>
    </div>
  </ng-template>
</div>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-confirmation-modal-form #cancelLicenceConfirmationModal
  (modalYes)="yesCancelLicence()"
></app-confirmation-modal-form>

<app-confirmation-modal-form #deleteLicenceConfirmationModal
  (modalYes)="yesDeleteLicence()"
></app-confirmation-modal-form>

<app-input-modal-form #inputModalForm
  [input0EnforceGreaterThan0]="true"
  [input0EnforceIntegerInput]="true"
  (thisFormSaved)="inputModalFormSubmitted($event)"
  (thisFormSavedExt)="inputModalFormSubmittedExt($event)"
></app-input-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
